function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_26_2",
  "data-name": "Component 26 \\u2013 2",
  transform: "translate(2.828 2.828)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  x2: 12,
  y2: 12,
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "Component_25_1",
  "data-name": "Component 25 \\u2013 1"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_13",
  "data-name": "Line 13",
  y1: 12,
  x2: 12,
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeWidth: 4
})));

var SvgNoHandlingCosts = function SvgNoHandlingCosts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.657,
    height: 17.657,
    viewBox: "0 0 17.657 17.657",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoHandlingCosts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-handling-costs.21548dea.svg";
export { ForwardRef as ReactComponent };